import moment, { Moment } from 'moment';
import { TopTooltip } from 'ui/tooltip';
import { DATE_FORMAT_FULL_WITH_TIME } from 'utils/date';
import { TooltipTrigger } from './Organization.styled';

type Props = {
  date: Moment;
};

/** Displays a relative date, and displays the full date on mouseover */
export default ({ date }: Props) => {
  return !date ? (
    <span>Never</span>
  ) : (
    <TopTooltip tooltipContent={<span>{moment(date).format(DATE_FORMAT_FULL_WITH_TIME)}</span>}>
      <TooltipTrigger>{moment(date).fromNow()}</TooltipTrigger>
    </TopTooltip>
  );
};
